import React from "react";
import TableText from "@/components/table/TableText";
import { numConvert, calculation, sum } from "@/method";
import _ from 'lodash'
import moment from 'moment'

const totalIndex = [7, 10, 13, 14];

export default (data, { date, last }) => {
    const lastIndex = data.length - 1;
    // 计算总计数据
    data.forEach((item, i) => {
        ['dayRn', 'dayRev'].forEach(name => {
            data[7][name] = data.reduce((a, b, index) => index < 7 ? a + numConvert(b[name]) : a, 0).toFixed(2);
            data[10][name] = sum([
                data[8][name], data[9][name]
            ]);
            data[13][name] = sum([
                data[11][name], data[12][name]
            ]);
            data[14][name] = sum([
                data[7][name], data[10][name], data[13][name]
            ]);
        });
    });
    // 计算当月MTD，利用昨日MTD加上今日数据
    ['Rn', 'Rev'].forEach(name => {
        data.forEach((item, i) => {
            data[i][`month${name}`] = sum([
                _.get(last, `${i}.month${name}`),
                _.get(data, `${i}.day${name}`)
            ]);
        });
    });

    // 计算占比、平均房价、房价占比
    const listName = ['day', 'month', 'budget', 'forecast', 'last'];
    listName.forEach(name => {
        data.forEach((item, i) => {
            // 间夜占比
            data[i][`${name}Abr`] = calculation(data[i][`${name}Rn`], data[lastIndex][`${name}Rn`], 4);
            // 平均房价
            data[i][`${name}Adr`] = calculation(data[i][`${name}Rev`], data[i][`${name}Rn`]);
            // 收益占比
            data[i][`${name}RevAbr`] = calculation(data[i][`${name}Rev`], data[lastIndex][`${name}Rev`], 4);
        });
    });

    // vs 对比数据
    data.forEach((item, i) => {
        // 当月MTD VS 当月Budget % Variance
        data[i].varRn = calculation(data[i].monthRn - data[i].budgetRn, data[i].budgetRn, 4);
        data[i].varAdr = calculation(data[i].monthAdr - data[i].budgetAdr, data[i].budgetAdr, 4);
        data[i].varRev = calculation(data[i].monthRev - data[i].budgetRev, data[i].budgetRev, 4);

        // 当月MTD VS 当月Forecast % Variance
        data[i].varForecastRn = calculation(data[i].monthRn - data[i].forecastRn, data[i].forecastRn, 4);
        data[i].varForecastAdr = calculation(data[i].monthAdr - data[i].forecastAdr, data[i].forecastAdr, 4);
        data[i].varForecastRev = calculation(data[i].monthRev - data[i].forecastRev, data[i].forecastRev, 4);

        // 当月MTD VS 去年当月Actual % Variance
        data[i].varLastRn = calculation(data[i].monthRn - data[i].lastRn, data[i].lastRn, 4);
        data[i].varLastAdr = calculation(data[i].monthAdr - data[i].lastAdr, data[i].lastAdr, 4);
        data[i].varLastRev = calculation(data[i].monthRev - data[i].lastRev, data[i].lastRev, 4);
    });

    return data
}

export const fillData = ({ data, e4_1_1, date }) => {
    const month = moment(date).format('M');
    const _index = (month - 1) * 3;
    const listName = {
        'best': 0,
        'corporate': 1,
        'government': 2,
        'packges': 3,
        'wholesale': 4,
        'commerce': 5,
        'discounts': 6,
        'total': 7,
        'business': 8,
        'leisure': 9,
        'group_total': 10,
        "contracts": 11,
        'others': 12,
        'grand': 14,
    };

    Object.keys(listName).forEach(name => {
        // 例如 当前9.2 获取4.1.1 八月数据 sep的三行数据
        // 从4.1.1 获取Budget 对应月份的数据填充
        data[listName[name]].budgetRn = _.get(e4_1_1, `${_index}.${name}_rn`, 0);
        data[listName[name]].budgetRev = _.get(e4_1_1, `${_index}.${name}_rev`, 0);
        // 预测
        data[listName[name]].forecastRn = _.get(e4_1_1, `${_index + 1}.${name}_rn`, 0);
        data[listName[name]].forecastRev = _.get(e4_1_1, `${_index + 1}.${name}_rev`, 0);
        // 去年
        data[listName[name]].lastRn = _.get(e4_1_1, `${_index + 2}.${name}_rn`, 0);
        data[listName[name]].lastRev = _.get(e4_1_1, `${_index + 2}.${name}_rev`, 0);

    });

    return data
}


export const columns = (onChange, date, print) => {
    return [
        {
            title: `细分市场`,
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 200,
            fixed: print ? false : "left",
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'text',
                    name: "name",
                    onChange,
                    totalIndex,
                };

                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `当日Actual`,
            width: 750,
            children: [{
                title: `间夜`,
                dataIndex: 'dayRn',
                key: 'dayRn',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当日Actual', '间夜'];
                    const props = {
                        text,
                        index,
                        type: !totalIndex.includes(index) && !print ? 'inputNumber' : 'number',
                        name: "dayRn",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `占比`,
                dataIndex: 'dayAbr',
                key: 'dayAbr',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当日Actual', '占比'];
                    const props = {
                        text,
                        index,
                        type: 'percent',
                        name: "dayAbr",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `平均房价`,
                dataIndex: 'dayAdr',
                key: 'dayAdr',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当日Actual', '平均房价'];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "dayAdr",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `客房收益`,
                dataIndex: 'dayRev',
                key: 'dayRev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当日Actual', '客房收益'];
                    const props = {
                        text,
                        index,
                        type: !totalIndex.includes(index) && !print ? 'inputNumber' : 'number',
                        name: "dayRev",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `占比`,
                dataIndex: 'dayRevAbr',
                key: 'dayRevAbr',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当日Actual', '占比'];
                    const props = {
                        text,
                        index,
                        type: 'percent',
                        name: "dayRevAbr",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }]
        },
        {
            title: `当月MTD`,
            width: 750,
            children: [{
                title: `间夜`,
                dataIndex: 'monthRn',
                key: 'monthRn',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月MTD', '间夜'];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "monthRn",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `占比`,
                dataIndex: 'monthAbr',
                key: 'monthAbr',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月MTD', '占比'];
                    const props = {
                        text,
                        index,
                        type: 'percent',
                        name: "monthAbr",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `平均房价`,
                dataIndex: 'monthAdr',
                key: 'monthAdr',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月MTD', '平均房价'];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "monthAdr",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `客房收益`,
                dataIndex: 'monthRev',
                key: 'monthRev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月MTD', '客房收益'];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "monthRev",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `占比`,
                dataIndex: 'monthRevAbr',
                key: 'monthRevAbr',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月MTD', '占比'];
                    const props = {
                        text,
                        index,
                        type: 'percent',
                        name: "monthRevAbr",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }]
        },
        {
            title: `当月Budget`,
            width: 750,
            children: [{
                title: `间夜`,
                dataIndex: 'budgetRn',
                key: 'budgetRn',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月Budget', '间夜'];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "budgetRn",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `占比`,
                dataIndex: 'budgetAbr',
                key: 'budgetAbr',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月Budget', '占比'];
                    const props = {
                        text,
                        index,
                        type: 'percent',
                        name: "budgetAbr",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `平均房价`,
                dataIndex: 'budgetAdr',
                key: 'budgetAdr',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月Budget', '平均房价'];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "budgetAdr",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `客房收益`,
                dataIndex: 'budgetRev',
                key: 'budgetRev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月Budget', '客房收益'];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "budgetRev",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `占比`,
                dataIndex: 'budgetRevAbr',
                key: 'budgetRevAbr',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月Budget', '占比'];
                    const props = {
                        text,
                        index,
                        type: 'percent',
                        name: "budgetRevAbr",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }]
        },
        {
            title: `当月MTD VS 当月Budget % Variance`,
            width: 450,
            children: [{
                title: `间夜%`,
                dataIndex: 'varRn',
                key: 'varRn',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月MTD VS 当月Budget % Variance', '间夜%'];
                    const props = {
                        text,
                        index,
                        type: 'percent',
                        name: "varRn",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `平均房价%`,
                dataIndex: 'varAdr',
                key: 'varAdr',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月MTD VS 当月Budget % Variance', '平均房价%'];
                    const props = {
                        text,
                        index,
                        type: 'percent',
                        name: "varAdr",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `客房收益%`,
                dataIndex: 'varRev',
                key: 'varRev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月MTD VS 当月Budget % Variance', '客房收益%'];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "varRev",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }]
        },
        {
            title: `当月Forecast`,
            width: 750,
            children: [{
                title: `间夜`,
                dataIndex: 'forecastRn',
                key: 'forecastRn',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月Forecast', '间夜'];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "forecastRn",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `占比`,
                dataIndex: 'forecastAbr',
                key: 'forecastAbr',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月Forecast', '占比'];
                    const props = {
                        text,
                        index,
                        type: 'percent',
                        name: "forecastAbr",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `平均房价`,
                dataIndex: 'forecastAdr',
                key: 'forecastAdr',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月Forecast', '平均房价'];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "forecastAdr",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `客房收益`,
                dataIndex: 'forecastRev',
                key: 'forecastRev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月Forecast', '客房收益'];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "forecastRev",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `占比`,
                dataIndex: 'forecastRevAbr',
                key: 'forecastRevAbr',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月Forecast', '占比'];
                    const props = {
                        text,
                        index,
                        type: 'percent',
                        name: "forecastRevAbr",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }]
        },
        {
            title: `当月MTD VS 当月Forecast % Variance`,
            width: 450,
            children: [{
                title: `间夜%`,
                dataIndex: 'varForecastRn',
                key: 'varForecastRn',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月MTD VS 当月Forecast % Variance', '间夜%'];
                    const props = {
                        text,
                        index,
                        type: 'percent',
                        name: "varForecastRn",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `平均房价%`,
                dataIndex: 'varForecastAdr',
                key: 'varForecastAdr',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月MTD VS 当月Forecast % Variance', '平均房价%'];
                    const props = {
                        text,
                        index,
                        type: 'percent',
                        name: "varForecastAdr",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `客房收益%`,
                dataIndex: 'varForecastRev',
                key: 'varForecastRev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月MTD VS 当月Forecast % Variance', '客房收益%'];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "varForecastRev",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }]
        },
        {
            title: `去年当月Actual`,
            width: 750,
            children: [{
                title: `间夜`,
                dataIndex: 'lastRn',
                key: 'lastRn',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['去年当月Actual', '间夜'];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "lastRn",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `占比`,
                dataIndex: 'lastAbr',
                key: 'lastAbr',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['去年当月Actual', '占比'];
                    const props = {
                        text,
                        index,
                        type: 'percent',
                        name: "lastAbr",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `平均房价`,
                dataIndex: 'lastAdr',
                key: 'lastAdr',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['去年当月Actual', '平均房价'];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "lastAdr",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `客房收益`,
                dataIndex: 'lastRev',
                key: 'lastRev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['去年当月Actual', '客房收益'];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "lastRev",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `占比`,
                dataIndex: 'lastRevAbr',
                key: 'lastRevAbr',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['去年当月Actual', '占比'];
                    const props = {
                        text,
                        index,
                        type: 'percent',
                        name: "lastRevAbr",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }]
        },
        {
            title: `当月MTD VS 去年当月Actual % Variance`,
            width: 450,
            children: [{
                title: `间夜%`,
                dataIndex: 'varLastRn',
                key: 'varLastRn',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月MTD VS 去年当月Actual % Variance', '间夜%'];
                    const props = {
                        text,
                        index,
                        type: 'percent',
                        name: "varLastRn",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `平均房价%`,
                dataIndex: 'varLastAdr',
                key: 'varLastAdr',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月MTD VS 去年当月Actual % Variance', '平均房价%'];
                    const props = {
                        text,
                        index,
                        type: 'percent',
                        name: "varLastAdr",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `客房收益%`,
                dataIndex: 'varLastRev',
                key: 'varLastRev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['当月MTD VS 去年当月Actual % Variance', '客房收益%'];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "varLastRev",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_2_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }]
        }
    ]
}


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2/4.2.2/compute.js